import { useState } from 'react';
import SimpleModal from '../SimpleModal';
import { createCategory } from '../../api/categoriesApi';
import { useToast } from '../../context/ToastContext';
import { useUndoRedo } from '../../context/UndoRedoContext';
import { usePlaylist } from '../../context/PlaylistContext';

export default function CreateCategoryModal({ show, onClose }: { show: boolean; onClose: () => void }) {
  const { showToast } = useToast();
  const { refreshEditor } = useUndoRedo();
  const { playlistId } = usePlaylist();
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);

  async function onSave() {
    const n = name.trim();
    if (!playlistId) {
      showToast('First select a playlist from Playlist manager.', 'warning');
      return;
    }
    if (!n) {
      showToast('Category name is required.', 'warning');
      return;
    }

    setBusy(true);
    try {
      const result = await createCategory({ playlist_id: Number(playlistId), name: n });
      if (!result.success) {
        showToast(result.message || 'Failed to create category', 'error');
        return;
      }
      showToast(result.message || 'Category created', 'success');
      setName('');
      onClose();
      await refreshEditor();
    } finally {
      setBusy(false);
    }
  }

  return (
    <SimpleModal
      show={show}
      onClose={onClose}
      title="Create new category"
      size="md"
      footer={
        <div className="d-flex justify-content-end gap-2 w-100">
          <button type="button" className="btn btn-outline-secondary" onClick={onClose} disabled={busy}>
            Cancel
          </button>
          <button type="button" className="btn btn-primary" onClick={() => void onSave()} disabled={busy}>
            {busy ? <span className="spinner-border spinner-border-sm" /> : 'Create category'}
          </button>
        </div>
      }
    >
      <div className="mb-3">
        <label className="form-label">Category name *</label>
        <input
          className="form-control"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="e.g. News"
        />
      </div>
      <div className="small text-muted">Category will be created in currently selected playlist.</div>
    </SimpleModal>
  );
}
